module.exports = __webpack_public_path__ + "img/mz.mz525b137.svg";